export default __webpack_public_path__ + "static/char-12-anr-b5a0d1cc4481198ac601561579cdfa6b.gif";